function buildJsonLdWebSite() {
  const context = { '@context': 'http://schema.org' };
  const type = { '@type': 'WebSite' };
  const name = { name: 'Rakuten' };
  const url = { url: 'https://fr.shopping.rakuten.com' };

  const structuredJsonLdWebSite = Object.assign({}, context, type, name, url);
  structuredJsonLdWebSite.potentialAction = {
    '@type': 'SearchAction',
    target: 'https://fr.shopping.rakuten.com/search/{search_term}',
    'query-input': 'required name=search_term',
  };
  return structuredJsonLdWebSite;
}
function getJsonLdWebSite() {
  return JSON.stringify(buildJsonLdWebSite(), null, ' ');
}

export {
  getJsonLdWebSite,
};
